import { render, staticRenderFns } from "./MessagesGroup.vue?vue&type=template&id=35cea0d8&scoped=true"
import script from "./MessagesGroup.vue?vue&type=script&lang=js"
export * from "./MessagesGroup.vue?vue&type=script&lang=js"
import style0 from "./MessagesGroup.vue?vue&type=style&index=0&id=35cea0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cea0d8",
  null
  
)

export default component.exports